import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('service/add',param)
}

export function update(param) {
  return axiosInstance.post('service/edit',param)
}

export function del(param) {
	return axiosInstance.post('service/del', param)
}

export function query(param) {
  return axiosInstance.post('service/query',param)
}

export function queryDetail(param) {
  return axiosInstance.post('service/queryDetail',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryService(param) {
  return axiosInstance.post('service/query',param)
}